<script>
  export let id;
  export let motivo;
  export let propuestaRevisores;
  export let onReject;

  import RechazarRevisionPropuesta from "../components/RechazarRevisionPropuesta.svelte";

  import { post } from "../utils/api.js";
  import { dictionary } from "../utils/stores.js";

  let dict;

  const unsubscribe = dictionary.subscribe(value => {
    dict = value;
  });

  let proponerRevisores = false;
  let revisorNombre = "";
  let revisorInstitucion = "";
  let revisorEmail = "";

  let divErrorEmail;
  let divErrorNombre;
  let divErrorInstitucion;

  let errorMsg = "";

  let checkErrors = () => {
    errorMsg = "";
    const error =
      revisorNombre === "" ||
      revisorInstitucion === "" ||
      revisorEmail === "" ||
      divErrorNombre.classList.contains("has-error") ||
      divErrorInstitucion.classList.contains("has-error") ||
      divErrorEmail.classList.contains("has-error");
    if (error) {
      errorMsg = dict["errorPropuesta"];
    }
    return error;
  };

  let addPropuestaRevisor = () => {
    const error = checkErrors();
    if (!error) {
      const pos = propuestaRevisores.findIndex(item => {
        return item.email === revisorEmail;
      });
      if (pos === -1) {
        propuestaRevisores.push({
          nombreCompleto: revisorNombre,
          institucion: revisorInstitucion,
          email: revisorEmail
        });
      }
      revisorNombre = "";
      revisorInstitucion = "";
      revisorEmail = "";
      propuestaRevisores = propuestaRevisores;
    }
  };

  let removePropuestaRevisor = index => {
    propuestaRevisores.splice(index, 1);
    propuestaRevisores = propuestaRevisores;
  };
</script>

<style>
  span.black {
    color: var(--revista-black);
  }

  div.add {
    justify-content: flex-start;
  }

  div.preguntaPropuesta {
    margin-top: 30px;
  }

  div.propuestas {
    margin-top: 20px;
    width: 100%;
  }
</style>

<div class="modal show" {id} tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{dict['rechazarRevision']}</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>
          <span class="black">{dict['motivo']}:</span>
        </p>
        <p />
        <select bind:value={motivo}>
          <option value="noTiempo">{dict['noTiempo']}</option>
          <option value="noExperto">{dict['noExperto']}</option>
          <option value="noOthers">{dict['noOthers']}</option>
        </select>
        <p />
        <div class="preguntaPropuesta">
          <input type="checkbox" bind:checked={proponerRevisores} />
          <span>{dict['propuestaRevisores']}</span>
        </div>
        {#if proponerRevisores}
          <form class="rd-form rd-mailform">
            {#if errorMsg !== ''}
              <div class="alert alert-danger" role="alert">{errorMsg}</div>
            {/if}
            <div class="form-wrap" bind:this={divErrorNombre}>
              <input
                class="form-input"
                id="nombreCompleto"
                type="text"
                placeholder={dict['nombreCompleto']}
                data-constraints="@Required"
                bind:value={revisorNombre} />
            </div>
            <div class="form-wrap" bind:this={divErrorInstitucion}>
              <input
                class="form-input"
                id="institucion"
                type="text"
                placeholder={dict['institucion']}
                data-constraints="@Required"
                bind:value={revisorInstitucion} />
            </div>
            <div class="form-wrap" bind:this={divErrorEmail}>
              <input
                class="form-input"
                id="email"
                type="text"
                placeholder={dict['email']}
                data-constraints="@Required"
                bind:value={revisorEmail} />
            </div>
            <div class="form-wrap add">
              <div
                class="button button-sm button-primary"
                on:click={() => addPropuestaRevisor()}>
                {dict['anadir']}
              </div>
            </div>
          </form>
          <div class="propuestas">
            {#each propuestaRevisores as propuestaRevisor, index}
              <RechazarRevisionPropuesta
                {propuestaRevisor}
                onRemove={() => removePropuestaRevisor(index)} />
            {/each}
          </div>
        {/if}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" on:click={onReject}>
          {dict['rechazar']}
        </button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          {dict['cancelar']}
        </button>
      </div>
    </div>
  </div>
</div>
